import css from "../footerNewsletter/FooterNewsletter.module.scss";

const SocialMediaLinks = () => {
  const imgInstagram = "/static/images/footer/icon-ig.svg";
  const imgTikTok = "/static/images/footer/icon-tiktok.svg";
  const imgFacebook = "/static/images/footer/icon-fb.svg";
  const imgPinterest = "/static/images/footer/icon-pinterest-new.svg";
  const imgYoutube = "/static/images/footer/icon-youtube.svg";
  const imgLinkedIn = "/static/images/footer/icon-linkedin.svg";

  const socialLinks = [
    {
      label: "Instagram",
      href: "https://www.instagram.com/milleetunelistes/",
      src: imgInstagram,
    },
    {
      label: "TikTok",
      href: "https://www.tiktok.com/@milleetunelistes",
      src: imgTikTok,
    },
    {
      label: "Facebook",
      href: "https://www.facebook.com/1001listes",
      src: imgFacebook,
    },
    {
      label: "Pinterest",
      href: "https://www.pinterest.fr/milletunelistes/_saved/",
      src: imgPinterest,
    },
    {
      label: "YouTube",
      href: "https://www.youtube.com/@1001listes",
      src: imgYoutube,
    },
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/company/milleetunelistes",
      src: imgLinkedIn,
    },
  ];

  return (
    <div className={css.socialRow}>
      {socialLinks.map((link) => (
        <a
          key={link.label}
          href={link.href}
          className={css.socialIcon}
          target="_blank"
          rel="noreferrer"
        >
          <img src={link.src} alt={link.label} />
        </a>
      ))}
    </div>
  );
};

export default SocialMediaLinks;
